var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.448 511.448",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M348.513,290.52c56.337,0,102.179,45.842,102.179,102.179S404.85,494.878,348.513,494.878H162.934 c-56.337,0-102.179-45.842-102.179-102.179S106.598,290.52,162.934,290.52H348.513z M246.334,392.699 c0-45.986-37.414-83.4-83.4-83.4s-83.4,37.414-83.4,83.4s37.414,83.4,83.4,83.4S246.334,438.685,246.334,392.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M348.513,16.57c56.337,0,102.179,45.842,102.179,102.179S404.85,220.928,348.513,220.928H162.934 c-56.337,0-102.179-45.842-102.179-102.179S106.598,16.57,162.934,16.57H348.513z M431.914,118.749c0-45.986-37.414-83.4-83.4-83.4 s-83.4,37.414-83.4,83.4s37.414,83.4,83.4,83.4S431.914,164.735,431.914,118.749z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5cff85"
    },
    d: "M162.934,325.868c36.851,0,66.831,29.98,66.831,66.831s-29.98,66.831-66.831,66.831 s-66.831-29.98-66.831-66.831S126.083,325.868,162.934,325.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5cff85"
    },
    d: "M348.513,51.918c36.851,0,66.831,29.98,66.831,66.831s-29.98,66.831-66.831,66.831 s-66.831-29.98-66.831-66.831S311.663,51.918,348.513,51.918z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535757"
    },
    d: "M348.513,0c65.483,0,118.749,53.266,118.749,118.749s-53.266,118.749-118.749,118.749H162.934 c-65.483,0-118.749-53.266-118.749-118.749S97.451,0,162.934,0H348.513z M450.693,118.749c0-56.337-45.842-102.179-102.179-102.179 H162.934c-56.337,0-102.179,45.842-102.179,102.179s45.843,102.179,102.179,102.179h185.579 C404.85,220.928,450.693,175.085,450.693,118.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535757"
    },
    d: "M348.513,273.95c65.483,0,118.749,53.266,118.749,118.749s-53.266,118.749-118.749,118.749H162.934 c-65.483,0-118.749-53.266-118.749-118.749S97.451,273.95,162.934,273.95H348.513z M450.693,392.699 c0-56.337-45.842-102.179-102.179-102.179H162.934c-56.337,0-102.179,45.842-102.179,102.179s45.843,102.179,102.179,102.179 h185.579C404.85,494.878,450.693,449.036,450.693,392.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535757"
    },
    d: "M348.513,35.348c45.986,0,83.4,37.414,83.4,83.4s-37.414,83.4-83.4,83.4s-83.4-37.414-83.4-83.4 S302.527,35.348,348.513,35.348z M415.344,118.749c0-36.851-29.98-66.831-66.831-66.831s-66.831,29.98-66.831,66.831 s29.98,66.831,66.831,66.831S415.344,155.599,415.344,118.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535757"
    },
    d: "M162.934,309.299c45.986,0,83.4,37.414,83.4,83.4s-37.414,83.4-83.4,83.4s-83.4-37.414-83.4-83.4 S116.948,309.299,162.934,309.299z M229.765,392.699c0-36.851-29.98-66.831-66.831-66.831s-66.831,29.98-66.831,66.831 s29.98,66.831,66.831,66.831S229.765,429.55,229.765,392.699z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.53c1d9b0d83d66000777584f950e73c1.svg";
export { ForwardRef as ReactComponent };